import { useGetGameZoneCollection } from 'server';
import React, { useEffect, useState } from 'react';
import { useSocketSelector } from 'js/store/hooks';

import * as helpers from './helpers';
import { GamesFeaturesContext } from './context';
import { prop } from 'ramda';

export const withGameFeatures = (WrappedComponent) => (props) => {
    const [gamesFeatures, setGamesFeatures] = useState({});
    const [isLoaded, setIsLoaded] = useState(false);
    const getGameZoneCollection = useGetGameZoneCollection();
    const connected = useSocketSelector(prop('connected'));

    useEffect(() => {
        if (!connected || isLoaded) {
            return;
        }

        (async () => {
            const { games } = await getGameZoneCollection();

            setGamesFeatures(helpers.filterGamesFeatures(games));
            setIsLoaded(true);
        })();
    }, [getGameZoneCollection, isLoaded, connected]);

    return (
        <GamesFeaturesContext.Provider value={gamesFeatures}>
            <WrappedComponent {...props} />
        </GamesFeaturesContext.Provider>
    );
};
